import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextarea,{staticStyle:{"font-size":"0.85rem"},attrs:{"outlined":"","readonly":"","auto-grow":"","rows":"1","append-icon":"mdi-menu-down","dense":"","hide-details":"","value":_vm.displayText},on:{"click":_vm.onFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }